import { EventExistsGuard } from './event-exists.guard';
import { EventSearchResultsGuard } from './event-searchresults.guard';

export const guards: any[] = [EventExistsGuard, EventSearchResultsGuard];

export * from './event-exists.guard';
export * from './event-searchresults.guard';
